"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppointmentInfo;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _PatientRel = _interopRequireDefault(require("../PatientRel"));
var _ApptPurpose = _interopRequireDefault(require("../ApptPurpose"));
var _styles = require("./styles");
function AppointmentInfo(_ref) {
  var _context, _context2, _context3, _context4;
  let {
    patientRelTitle,
    appointmentEhrId,
    buttonConfig,
    patientRel,
    onPatientRelSelect,
    apptPurposeTitle,
    purpose,
    purposeOptionsByRel,
    hidePatientRel,
    showPurpose,
    onSelectPurpose,
    showNoBooking,
    NoBookingBanner,
    virtualVisitConfig,
    PleaseCallMessage,
    isApptPurposeLoading,
    apptPurposeFilterProps,
    formName
  } = _ref;
  if (NoBookingBanner && typeof NoBookingBanner === 'function') {
    NoBookingBanner = /*#__PURE__*/_react.default.createElement(NoBookingBanner, null);
  }
  if (PleaseCallMessage && typeof PleaseCallMessage === 'function') {
    PleaseCallMessage = /*#__PURE__*/_react.default.createElement(PleaseCallMessage, null);
  }
  const updatedButtonConfig = ((_context = buttonConfig) == null ? void 0 : (0, _bind.default)(_context2 = Function.call).call(_context2, (0, _map.default)(_context), _context))?.(e => ({
    ...e,
    disabled: Boolean(appointmentEhrId)
  }));
  const purposes = ((_context3 = purposeOptionsByRel[patientRel]) == null ? void 0 : (0, _bind.default)(_context4 = Function.call).call(_context4, (0, _map.default)(_context3), _context3))?.(purpose => ({
    ...purpose,
    disabled: Boolean(appointmentEhrId)
  }));
  return /*#__PURE__*/_react.default.createElement(_styles.AppointmentInfoForm, {
    id: formName,
    name: formName,
    onSubmit: e => e.preventDefault()
  }, !hidePatientRel && /*#__PURE__*/_react.default.createElement(_PatientRel.default, {
    patientRelTitle: patientRelTitle,
    buttonConfig: updatedButtonConfig,
    patientRel: patientRel,
    onSelect: onPatientRelSelect
  }), showNoBooking && patientRel && NoBookingBanner, showPurpose && patientRel ? /*#__PURE__*/_react.default.createElement(_ApptPurpose.default, {
    apptPurposeTitle: apptPurposeTitle,
    patientRel: patientRel,
    selectedPurpose: purpose,
    purposes: purposes,
    onSelect: onSelectPurpose,
    virtualVisitConfig: virtualVisitConfig,
    isApptPurposeLoading: isApptPurposeLoading,
    apptPurposeFilterProps: apptPurposeFilterProps
  }) : null, showPurpose && patientRel && PleaseCallMessage);
}
const propTypes = {
  /**
   * The EHR ID of the appointment
   */
  appointmentEhrId: _propTypes.string,
  /**
   * The title of patient relationship
   */
  patientRelTitle: _propTypes.node,
  /**
   * Patient relationship config data
   */
  buttonConfig: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    patient_type: _propTypes.string,
    button_text: _propTypes.node
  })).isRequired,
  /**
   * Available Appointment purpose list to be displayed when patient relationship selected
   */
  purposeOptionsByRel: (0, _propTypes.shape)({
    new: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      name: _propTypes.string
    })),
    established: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      name: _propTypes.string
    }))
  }).isRequired,
  /**
   * The title of appointment purpose
   * This can be configurable via config application strings - 'appointment_info.appt_purpose_title'
   * If key doesn't exist then used the passed value as title
   */
  apptPurposeTitle: _propTypes.node,
  /**
   * callback function to select patient relationship
   */
  onPatientRelSelect: _propTypes.func.isRequired,
  /**
   * callback function to select appointment purpose
   */
  onSelectPurpose: _propTypes.func.isRequired,
  /**
   * Set patient relationship type once fired 'onPatientRelSelect' callback function
   */
  patientRel: _propTypes.string,
  /**
   * Set appointment purpose once fired 'onSelectPurpose' callback function
   */
  purpose: (0, _propTypes.shape)({
    name: _propTypes.string
  }),
  /**
   * Determines whether or not to hide the patient rel question. Make sure you pass a patientRel in if you hide the question!
   */
  hidePatientRel: _propTypes.bool,
  /**
   * Expect truthy value to display available purpose list
   */
  showPurpose: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.bool]),
  /**
   * Expect truthy value to display banner or warning messages
   */
  showNoBooking: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.bool]),
  /**
   * Expect DOM node or React element to display when showNoBooking prop is true
   */
  NoBookingBanner: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.element, _propTypes.elementType]),
  /**
   * Label text to be display when virtual visit exists
   */
  virtualVisitConfig: (0, _propTypes.shape)({
    phone: _propTypes.string,
    video: _propTypes.string,
    in_person: _propTypes.string
  }),
  /**
   * Expect DOM node or React element for "please call" messaging
   * Optional => displayed only if passed down
   * Enables consuming app to internationalize and style phone numbers, etc., as desired
   */
  PleaseCallMessage: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.element, _propTypes.elementType]),
  /**
   * Expect truthy value to display shimmer loading state
   * by default it's false
   */
  isApptPurposeLoading: _propTypes.bool,
  /* Properties for the appointment purpose filter controls */
  apptPurposeFilterProps: (0, _propTypes.shape)({
    /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
    minPurposesForFilter: _propTypes.number,
    /* Labels for rendering the filter controls */
    labels: (0, _propTypes.shape)({
      noResultsLabel: _propTypes.string,
      purposeSearchLabel: _propTypes.string,
      purposeSearchPlaceholderLabel: _propTypes.string,
      visitTypeAllLabel: _propTypes.string,
      visitTypeInPersonLabel: _propTypes.string,
      visitTypeVirtualLabel: _propTypes.string
    }),
    /* Function executed when the name filter changes */
    onNameFilterChange: _propTypes.func,
    /* Function executed when the visit type filter changes */
    onVisitTypeFilterChange: _propTypes.func,
    /* Function executed when the filters are cleared */
    onClearFilters: _propTypes.func
  }),
  /* Applied as the containing form's name & id */
  formName: _propTypes.string.isRequired
};
const defaultProps = {
  patientRelTitle: '',
  apptPurposeTitle: '',
  showNoBooking: false,
  hidePatientRel: false,
  showPurpose: true,
  patientRel: '',
  purpose: {
    name: ''
  },
  virtualVisitConfig: {
    phone: 'Phone Visit',
    video: 'Video Visit',
    in_person: 'In Person'
  },
  isApptPurposeLoading: false
};
AppointmentInfo.propTypes = propTypes;
AppointmentInfo.defaultProps = defaultProps;
AppointmentInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppointmentInfo",
  "props": {
    "patientRelTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The title of patient relationship",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "apptPurposeTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The title of appointment purpose\nThis can be configurable via config application strings - 'appointment_info.appt_purpose_title'\nIf key doesn't exist then used the passed value as title",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "showNoBooking": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Expect truthy value to display banner or warning messages",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }, {
          "name": "bool"
        }]
      },
      "required": false
    },
    "hidePatientRel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Determines whether or not to hide the patient rel question. Make sure you pass a patientRel in if you hide the question!",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showPurpose": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Expect truthy value to display available purpose list",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }, {
          "name": "bool"
        }]
      },
      "required": false
    },
    "patientRel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Set patient relationship type once fired 'onPatientRelSelect' callback function",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "purpose": {
      "defaultValue": {
        "value": "{\n  name: ''\n}",
        "computed": false
      },
      "description": "Set appointment purpose once fired 'onSelectPurpose' callback function",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "virtualVisitConfig": {
      "defaultValue": {
        "value": "{\n  phone: 'Phone Visit',\n  video: 'Video Visit',\n  in_person: 'In Person'\n}",
        "computed": false
      },
      "description": "Label text to be display when virtual visit exists",
      "type": {
        "name": "shape",
        "value": {
          "phone": {
            "name": "string",
            "required": false
          },
          "video": {
            "name": "string",
            "required": false
          },
          "in_person": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "isApptPurposeLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Expect truthy value to display shimmer loading state\nby default it's false",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "appointmentEhrId": {
      "description": "The EHR ID of the appointment",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "buttonConfig": {
      "description": "Patient relationship config data",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "patient_type": {
              "name": "string",
              "required": false
            },
            "button_text": {
              "name": "node",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "purposeOptionsByRel": {
      "description": "Available Appointment purpose list to be displayed when patient relationship selected",
      "type": {
        "name": "shape",
        "value": {
          "new": {
            "name": "arrayOf",
            "value": {
              "name": "shape",
              "value": {
                "name": {
                  "name": "string",
                  "required": false
                }
              }
            },
            "required": false
          },
          "established": {
            "name": "arrayOf",
            "value": {
              "name": "shape",
              "value": {
                "name": {
                  "name": "string",
                  "required": false
                }
              }
            },
            "required": false
          }
        }
      },
      "required": true
    },
    "onPatientRelSelect": {
      "description": "callback function to select patient relationship",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onSelectPurpose": {
      "description": "callback function to select appointment purpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "NoBookingBanner": {
      "description": "Expect DOM node or React element to display when showNoBooking prop is true",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "element"
        }, {
          "name": "elementType"
        }]
      },
      "required": false
    },
    "PleaseCallMessage": {
      "description": "Expect DOM node or React element for \"please call\" messaging\nOptional => displayed only if passed down\nEnables consuming app to internationalize and style phone numbers, etc., as desired",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "element"
        }, {
          "name": "elementType"
        }]
      },
      "required": false
    },
    "apptPurposeFilterProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "minPurposesForFilter": {
            "name": "number",
            "required": false
          },
          "labels": {
            "name": "shape",
            "value": {
              "noResultsLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchPlaceholderLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeAllLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeInPersonLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeVirtualLabel": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "onNameFilterChange": {
            "name": "func",
            "required": false
          },
          "onVisitTypeFilterChange": {
            "name": "func",
            "required": false
          },
          "onClearFilters": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "formName": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};